import React, { useState, useRef, useEffect } from "react";
import { MoveHorizontal } from "lucide-react";
import { IMG } from "../../lib/site";
import { HOME } from "@/constants/testIds";

const BeforeAfterSlider = () => {
  const [pos, setPos] = useState(50);
  const [dragging, setDragging] = useState(false);
  const ref = useRef(null);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  };

  useEffect(() => {
    const up = () => setDragging(false);
    const mm = (e) => dragging && move(e.clientX);
    const tm = (e) => dragging && e.touches[0] && move(e.touches[0].clientX);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    window.addEventListener("mousemove", mm);
    window.addEventListener("touchmove", tm);
    return () => {
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchend", up);
      window.removeEventListener("mousemove", mm);
      window.removeEventListener("touchmove", tm);
    };
  }, [dragging]);

  return (
    <div
      ref={ref}
      onMouseDown={() => setDragging(true)}
      onTouchStart={() => setDragging(true)}
      className="relative w-full aspect-[16/11] overflow-hidden select-none cursor-ew-resize border border-zinc-800"
      data-testid={HOME.sliderContainer}
    >
      <img src={IMG.beforeConcrete} alt="Raw concrete before coating" className="absolute inset-0 w-full h-full object-cover" draggable="false" />
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={IMG.metallic}
          alt="PRYME EPOXY finished metallic floor"
          className="absolute inset-y-0 left-0 h-full object-cover max-w-none"
          style={{ width: ref.current?.getBoundingClientRect().width || "100%" }}
          draggable="false"
        />
      </div>

      <div className="absolute top-4 left-4 bg-black/75 px-3 py-1 text-xs uppercase tracking-widest text-zinc-300 font-semibold border border-zinc-700">
        Before: Raw Concrete
      </div>
      <div className="absolute top-4 right-4 bg-[#C69453] px-3 py-1 text-xs uppercase tracking-widest text-black font-bold">
        After: PRYME Finish
      </div>

      <div className="absolute inset-y-0 w-1 bg-[#C69453]" style={{ left: `${pos}%` }}>
        <div
          className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-12 h-12 bg-zinc-950 border-2 border-[#C69453] flex items-center justify-center shadow-2xl"
          data-testid={HOME.sliderHandle}
        >
          <MoveHorizontal className="w-6 h-6 text-[#C69453]" />
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
